var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "url_payload_view"
  }, [_vm.img_types.includes(_vm.fileType) ? _c('img', {
    attrs: {
      "src": _vm.url
    }
  }) : _c('div', {
    staticClass: "unknown"
  }, [_vm._m(0), _c('a', {
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.url))]), _c('p', {
    staticClass: "warn"
  }, [_vm._v("Do NOT click links you do not trust.")])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('span', [_vm._v("URL")])]);
}]

export { render, staticRenderFns }